import styled, { css } from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.neutral[2]};

  ${({ theme }) => {
    return css`
      padding: ${theme.spacing[2]}px ${theme.spacing[6]}px;
    `;
  }}
`;
